module.exports = "logo{outline:0}\n"